import api from './api';

const userService = {
  async getByRole(role) {
    const response = await api.get(`/users/role/${role}`);
    return response.data;
  },
};

export default userService;

